export const headers_usuarios = [
  {
    field: "idUsuario",
    title: "",
    visible: false,
    format: "",
    type: "",
    filter: false,
  },
  {
    field: "idEstatus",
    title: "",
    visible: false,
    format: "",
    type: "",
    filter: false,
  },
  {
    field: "estatus",
    title: "Estatus",
    visible: true,
    format: "",
    type: "",
    filter: false,
  },
  {
    field: "idPerfil",
    title: "",
    visible: false,
    format: "",
    type: "",
    filter: false,
  },
  {
    field: "descripcion",
    title: "Perfil",
    visible: true,
    format: "",
    type: "",
    filter: true,
  },
  {
    field: "nombre",
    title: "Nombre",
    visible: false,
    format: "",
    type: "",
    filter: true,
  },
  {
    field: "apellidoPat",
    title: "Paterno",
    visible: false,
    format: "",
    type: "",
    filter: true,
  },
  {
    field: "apellidoMat",
    title: "Materno",
    visible: false,
    format: "",
    type: "",
    filter: true,
  },
  {
    field: "fullName",
    title: "Nombre",
    visible: true,
    format: "",
    type: "",
    filter: true,
  },
  {
    field: "correo",
    title: "Correo",
    visible: true,
    format: "",
    type: "",
    filter: true,
  },
  {
    field: "buttons",
    title: "",
    visible: true,
    format: "",
    type: "buttons",
    filter: false,
    buttons: [{ type: "button", action: "edit", text: "Editar" }],
  },
  {
    field: "buttons",
    title: "",
    visible: true,
    format: "",
    type: "buttons",
    filter: false,
    buttons: [
      {
        type: "button",
        action: "config",
        text: "Configurar",
        pathIcon: "/images/configuracion-gear.png",
      },
    ],
  },
]

export const Header_Vistas = [
  {
    field: "descripcionMenu",
    text: "Nombre",
    visible: true,
    format: null,
    type: "text",
    filter: true,
  },
  {
    field: "status",
    text: "Estatus",
    visible: true,
    format: null,
    type: "text",
    filter: true,
  },
  {
    field: "",
    text: "Editar",
    visible: true,
    filter: false,
    format: null,
    type: "button",
    iconImg: `${process.env.PUBLIC_URL}/images/edit.png`,
    textBtn: null,
    styleBtn: {
      borderRadius: 20,
      backgroundColor: "",
      color: "#ffffff",
    },
    action: "editVista",
    styleTable: {
      header: {
        width: 80,
      },
    },
  },
  {
    field: "",
    text: "Agregar",
    visible: true,
    filter: false,
    format: null,
    type: "button",
    iconImg: `${process.env.PUBLIC_URL}/images/plus.png`,
    textBtn: null,
    styleBtn: {
      borderRadius: 20,
      backgroundColor: "",
      color: "#ffffff",
    },
    action: "addVistas",
    styleTable: {
      header: {
        width: 80,
      },
    },
  },
]

export const Header_Vistas_Sub = [
  {
    field: "descripcionMenu",
    text: "Nombre",
    visible: true,
    format: null,
    type: "text",
    filter: true,
  },
  {
    field: "status",
    text: "Estatus",
    visible: true,
    format: null,
    type: "text",
    filter: true,
  },
  {
    field: "",
    text: "Editar",
    visible: true,
    filter: false,
    format: null,
    type: "button",
    iconImg: `${process.env.PUBLIC_URL}/images/edit.png`,
    textBtn: null,
    styleBtn: {
      borderRadius: 20,
      backgroundColor: "",
      color: "#ffffff",
    },
    action: "editVista",
    styleTable: {
      header: {
        width: 80,
      },
    },
  },
  {
    field: "",
    text: "Agregar",
    visible: true,
    filter: false,
    format: null,
    type: "button",
    iconImg: `${process.env.PUBLIC_URL}/images/plus.png`,
    textBtn: null,
    styleBtn: {
      borderRadius: 20,
      backgroundColor: "",
      color: "#ffffff",
    },
    action: "addVistas",
    styleTable: {
      header: {
        width: 80,
      },
    },
  },
]
